import {useMutation} from "@apollo/client";
import pluralize from "pluralize";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_CHECKS_QUERY2, GQL_UPDATE_INTERVALS_STATE} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkSetIntervalsForm} from "@/pages/checks/list/actions/bulkSetIntervals/BulkSetIntervalsForm.tsx";

export interface EditCheckIntervalsFormValues {
  msp_interval: number;
}

export interface BulkSetIntervalsModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkSetIntervalsModal = ({selectedItemsIds, show, setShow, onSuccess}: BulkSetIntervalsModalProps) => {
  const [updateChecksInterval, {data, loading}] = useMutation<GraphQLResponse<null>>(GQL_UPDATE_INTERVALS_STATE, {
    refetchQueries: [GQL_CHECKS_QUERY2],
  });

  const handleSubmit = async (data: EditCheckIntervalsFormValues) => {
    const response = await updateChecksInterval({
      variables: {
        ids: selectedItemsIds,
        msp_interval: data.msp_interval,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const formId = "BulkSetIntervalsForm";
  return (
    <FormModal
      disabled={loading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={`Set Intervals on ${pluralize("Check", selectedItemsIds.length, true)}`}
    >
      <BulkSetIntervalsForm
        formId={formId}
        onSubmit={handleSubmit}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        onError={console.log}
      />
    </FormModal>
  );
};
